import {
  Cross1Icon,
  DragHandleHorizontalIcon,
  PersonIcon,
} from "@radix-ui/react-icons";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { LoginContainerViewContent } from "../Login/LoginContainerViewContent";
import { DialogTrigger, Dialog } from "../../components/ui/dialog";
import { useUser } from "../../contextApi/userContext";
import Dropdown from "./../../Global/customDropdown/OptionDropdowns";

export const MenuOptions = {
  HOME: "Home",
  EXPLORE_TRIPS: "Explore Trips",
  EXPLORER_CLUB: "Explorer Club",
  INFLUENCER_CLUB: "Influencer Club",
  TRIP_DIARY: "Trip Diary",
};

const menuOptionsArray = [
  { label: MenuOptions.HOME, url: "/" },
  { label: MenuOptions.EXPLORE_TRIPS, url: "/exploretrips" },
  { label: MenuOptions.EXPLORER_CLUB, url: "/explorerclub" },
  { label: MenuOptions.INFLUENCER_CLUB, url: "/influencerclub" },
  { label: MenuOptions.TRIP_DIARY, url: "/tripdiary" },
];

const Header = ({ activeTab, ...props }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showLoginDialogMobile, setShowLoginDialogMobile] = useState(false);
  const [showLoginDialogWeb, setShowLoginDialogWeb] = useState(false);
  const [showProfileOptions, setShowProfileOptions] = useState(false);
  const drawerRef = useRef();
  const userSetter = useUser();

  useEffect(() => {
    const handleOutsideClick = (event) => {
      // Check if the clicked element is outside the navigation drawer
      if (
        isMenuOpen &&
        drawerRef.current &&
        !drawerRef.current.contains(event.target)
      ) {
        setIsMenuOpen(false);
      }
    };

    // Attach the event listener to the document
    document.addEventListener("click", handleOutsideClick);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [isMenuOpen]);

  const buttonStyles =
    "bg-transparent rounded-full border border-solid border-black border-opacity-10 px-6 py-2 mx-2 text-black font-Aeonik text-base hover:bg-orange-600 hover:text-white";
  const selectedButtonStyles =
    "bg-orange-600 rounded-full border border-solid border-white border-opacity-10 px-6 py-2 mx-2 text-white font-Aeonik text-base";

  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const onDismissLoginInvoked = () => {
    setShowLoginDialogMobile(false);
    setShowLoginDialogWeb(false);
  };

  const userLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    userSetter.setUser({ role: "guest" });
    window.location.reload();
  };

  const exploreTripsNavigate = () => {
    navigate("/exploretrips");
  };

  const profileOptionsArray = [
    { label: "Explore Trips", action: exploreTripsNavigate },
    { label: "Logout", action: userLogout },
  ];

  // const adminPanelOption = {
  //   label: "Admin Panel",
  //   action: () => {
  //     navigate("/admin");
  //   }
  // }
  // admin: [
  //   { label: "Admin Panel", action: () => { navigate("/admin") } },
  //   { label: "Explore Trips", action: exploreTripsNavigate },
  //   { label: "Logout", action: userLogout }
  // ],

  const profileOptions = {
    admin: profileOptionsArray,
    user: profileOptionsArray,
    guest: profileOptionsArray
  }

  const headerWeb = (
    <div className="hidden lg:flex w-full justify-between items-center py-8 px-16 bg-transparent relative z-10">
      {/* Logo on the left */}
      <div>
        <img
          src="/images/exploro_icon.png"
          alt="Logo"
          className="h-10"
          onClick={() => {
            navigate("/");
          }}
        />
      </div>

      {/* Tabs in the center */}
      <div className="flex justify-center">
        {menuOptionsArray.map((menuOption, index) => (
          <button
            className={
              menuOption.label === activeTab
                ? selectedButtonStyles
                : buttonStyles
            }
            key={index}
            onClick={() => {
              navigate(menuOption.url);
            }}
          >
            {menuOption.label}
          </button>
        ))}
      </div>

      {/* Login button on the right */}
      {userSetter?.user?.role == "guest" && (
        <Dialog open={showLoginDialogWeb} onOpenChange={setShowLoginDialogWeb}>
          <DialogTrigger asChild>
            <button className="bg-transparent rounded-full border border-solid border-orange-600 font-Aeonik text-orange-600 px-6 py-2">
              Login
            </button>
          </DialogTrigger>
          {
            <LoginContainerViewContent
              onDismissLoginInvoked={onDismissLoginInvoked}
            />
          }
        </Dialog>
      )}
      {userSetter?.user?.role != "guest" && (
        <>
          <div className="flex flex-row">
            <div class="bg-white w-[2.6vw] h-[2.6vw] rounded-full border-2 border-[#ea580c] cursor-pointer box-border">
              <p className="h-[2.4vw] m-0 text-center leading-[2.4vw] text-[1.3vw] font-bold">
                {userSetter?.user?.firstName[0]}
              </p>
            </div>
            {<Dropdown options={profileOptions[`${userSetter?.user?.role}`]} />}
          </div>
        </>
      )}
    </div>
  );

  const headerMobile = (
    <div
      ref={drawerRef}
      className="lg:hidden w-full flex justify-between items-center py-8 px-3 bg-transparent relative z-10"
    >
      {/* Hamburger Menu Button on the left */}
      <DragHandleHorizontalIcon
        onClick={toggleMenu}
        className={"p-2 w-12 h-12"}
      />

      {/* Logo in the center */}
      <div className="text-center">
        <img
          onClick={() => {
            navigate("/");
          }}
          src="/images/exploro_logo.webp"
          alt="Logo"
          className="h-8 mt-2"
        />
      </div>

      {userSetter?.user?.role == "guest" && (
        <Dialog
          open={showLoginDialogMobile}
          onOpenChange={setShowLoginDialogMobile}
        >
          <DialogTrigger asChild>
            <div className="rounded-full px-2 py-2 border-orange-600 border-2 w-10 h-10 mt-1">
              <PersonIcon className="text-orange-600 h-4 mx-auto" />
            </div>
          </DialogTrigger>
          {
            <LoginContainerViewContent
              onDismissLoginInvoked={onDismissLoginInvoked}
            />
          }
        </Dialog>
      )}
      {userSetter?.user?.role != "guest" && (
        <>
          <div className="flex flex-row">
            <div class="bg-white w-[3.2vh] h-[3.2vh] rounded-full border-2 border-[#ea580c] cursor-pointer m-0">
              <p class="h-[3vh] m-0 text-center leading-[3vh] text-[1.6vh] font-bold">
                {userSetter?.user?.firstName[0]}
              </p>
            </div>
            <Dropdown options={profileOptions[`${userSetter?.user?.role}`]} />
          </div>
        </>
      )}

      {/* Mobile Menu (Hidden on Desktop) */}
      <div
        className={`lg:hidden w-2/3 fixed inset-0 z-50 overflow-hidden transition-all duration-300 ${
          isMenuOpen
            ? "transform -translate-x-0"
            : "transform -translate-x-full"
        }`}
      >
        <div className="bg-white text-black h-full flex flex-col w-70vw">
          {/* Close button */}
          <div className="text-right p-4">
            <button onClick={toggleMenu}>
              <Cross1Icon />
            </button>
          </div>

          {/* Mobile Menu Content */}
          <div className="flex-1 flex flex-col justify-items-center justify-center">
            {/* Menu Options */}
            {menuOptionsArray.map((menuOption, index) => (
              <button
                className={"bg-transparent p-4 text-center"}
                key={index}
                onClick={() => {
                  toggleMenu();
                  navigate(menuOption.url);
                }}
              >
                {menuOption.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  const headerMobileDarkTheme = (
    <div
      ref={drawerRef}
      className="lg:hidden w-full flex justify-between items-center py-1 px-3 bg-black relative z-10"
    >
      {/* Hamburger Menu Button on the left */}
      <DragHandleHorizontalIcon
        onClick={toggleMenu}
        className={"p-2 w-12 h-12 text-white"}
      />

      {/* Logo in the center */}
      <div className="text-center">
        <img
          onClick={() => {
            navigate("/");
          }}
          src="/images/exploro_white_logo_black_bg.webp"
          alt="Logo"
          className="h-8 mt-2 bg-white"
        />
      </div>

      {userSetter?.user?.role == "guest" && (
        <Dialog
          open={showLoginDialogMobile}
          onOpenChange={setShowLoginDialogMobile}
        >
          <DialogTrigger asChild>
            <div className="rounded-full px-2 py-2 border-white border-2 w-10 h-10 mt-1">
              <PersonIcon className="text-white h-4 mx-auto" />
            </div>
          </DialogTrigger>
          {
            <LoginContainerViewContent
              onDismissLoginInvoked={onDismissLoginInvoked}
            />
          }
        </Dialog>
      )}
      {userSetter?.user?.role != "guest" && (
        <>
          <div className="flex flex-row">
            <div class="bg-black w-[3.2vh] h-[3.2vh] rounded-full border-2 border-[#ffffff] cursor-pointer m-0">
              <p class="h-[3vh] m-0 text-center text-white leading-[3vh] text-[1.6vh] font-bold">
                {userSetter?.user?.firstName[0]}
              </p>
            </div>
            <Dropdown strokeColor={"white"} options={profileOptions[`${userSetter?.user?.role}`]} />
          </div>
        </>
      )}

      {/* Mobile Menu (Hidden on Desktop) */}
      <div
        className={`lg:hidden w-2/3 fixed inset-0 z-50 overflow-hidden transition-all duration-300 ${
          isMenuOpen
            ? "transform -translate-x-0"
            : "transform -translate-x-full"
        }`}
      >
        <div className="bg-white text-black h-full flex flex-col w-70vw">
          {/* Close button */}
          <div className="text-right p-4">
            <button onClick={toggleMenu}>
              <Cross1Icon />
            </button>
          </div>

          {/* Mobile Menu Content */}
          <div className="flex-1 flex flex-col justify-items-center justify-center">
            {/* Menu Options */}
            {menuOptionsArray.map((menuOption, index) => (
              <button
                className={"bg-transparent p-4 text-center"}
                key={index}
                onClick={() => {
                  toggleMenu();
                  navigate(menuOption.url);
                }}
              >
                {menuOption.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <>
      {headerWeb}
      {props.activeColor ? headerMobileDarkTheme : headerMobile}
    </>
  );
};

export default Header;
